import BaseTextField from './TextField';

// EXPORT
export const TextField = BaseTextField;
export type { TextFieldProps } from './TextField.interface';
